import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { swalMessage } from '@components/common';
import styled from 'styled-components';

const DESKTOP_FALLBACK_URL = 'https://letmeup.co.kr';
const FALLBACK_TIMEOUT = 2500;

const DeeplinkForwarder = () => {
  const { link } = useParams<{ link?: string }>();
  const run = () => {
    if (!link) return swalMessage('info', '잘못된 접근입니다.', '확인', false);

    const decodedLink = decodeURIComponent(link);
    const iOSConfig = {
      appId: '6743686410',
      appStoreUrl: 'https://apps.apple.com/app/id6743686410',
      deepLink: decodedLink,
    };
    const androidConfig = {
      packageName: 'com.samlab.letmeupapp',
      playStoreUrl: 'https://play.google.com/store/apps/details?id=com.samlab.letmeupapp',
      deepLink: decodedLink,
    };
    const userAgent = navigator.userAgent || navigator.vendor || window?.opera;
    let isMobile = false;
    let isIOS = false;
    let isAndroid = false;
    // iOS 감지
    if (/iPad|iPhone|iPod/.test(userAgent) && !window?.MSStream) {
      isIOS = true;
      isMobile = true;
    }
    // Android 감지
    else if (/android/i.test(userAgent)) {
      isAndroid = true;
      isMobile = true;
    }
    if (isMobile && isAndroid) {
      const appUrl = androidConfig.deepLink;
      window.location.href = appUrl;
      const storeRedirectTimeout = createTimeout(androidConfig.playStoreUrl);
      document.addEventListener('visibilitychange', () =>
        redirectTimeoutIfModernBrowser(storeRedirectTimeout),
      );
      window.addEventListener('blur', () => redirectTimeoutIfObsoleteBrowser(storeRedirectTimeout));
      return;
    }

    if (isMobile && isIOS) {
      const appUrl = iOSConfig.deepLink;
      window.location.href = appUrl;
      const storeRedirectTimeout = createTimeout(iOSConfig.appStoreUrl);
      document.addEventListener('visibilitychange', () =>
        redirectTimeoutIfModernBrowser(storeRedirectTimeout),
      );
      window.addEventListener('blur', () => redirectTimeoutIfObsoleteBrowser(storeRedirectTimeout));
      return;
    }
    // 모바일이 아니거나 OS를 감지할 수 없는 경우
    swalMessage(
      'info',
      '모바일 기기에서 사용 가능합니다.\n렛미업 안내 페이지로 이동합니다.',
      '확인',
      false,
      moveToFallbackUrl,
      moveToFallbackUrl,
    );
  };

  const redirectTimeoutIfModernBrowser = (timeout: NodeJS.Timeout) => {
    if (document.hidden) clearTimeout(timeout);
  };

  const redirectTimeoutIfObsoleteBrowser = (timeout: NodeJS.Timeout) => {
    clearTimeout(timeout);
  };

  const moveToFallbackUrl = () => {
    window.location.href = DESKTOP_FALLBACK_URL;
  };

  const createTimeout = (storeUrl: string) => {
    return setTimeout(() => {
      window.location.href = storeUrl;
    }, FALLBACK_TIMEOUT);
  };

  useEffect(() => {
    run();
  }, []);

  return (
    <ContentWrapper>
      <Text>앱을 실행하는 중입니다...</Text>
    </ContentWrapper>
  );
};

export default DeeplinkForwarder;

const ContentWrapper = styled.div`
  width: 100%;
  padding: 4rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Text = styled.span`
  font-size: 1.25rem;
`;
